var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide",class:_vm.cssClass,style:(_vm.style)},[(_vm.overlay)?_c('div',{staticClass:"overlay"}):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }